import React, {useEffect, useState} from 'react';
import Accordion from "./Accordion";
import {useNavigate} from "react-router-dom";
import ServicesLoader from "./ServicesLoader";
import {AiOutlineFile} from "react-icons/ai";
import {Button} from "@mui/material";
import EntitySelectorDialog from "./EntitySelectorDialog";

function Services({userRole = "USER"}) {
    const [accordionData, setAccordionData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupItem, setPopupItem] = useState(null);
    const navigate = useNavigate();
    const [selectedEntities, setSelectedEntities] = useState({entity: null, explanationEntity: null});
    const hasSecondStep = false;

    const fetchAccordionData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
            const data = await response.json();
            setAccordionData(data.data || []);
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        void fetchAccordionData();
    }, []);


    const renderAccordion = (accordionItem) => {
        const isLastLevel = !accordionItem.childrenPermitTypes || accordionItem.childrenPermitTypes.length === 0;

        if (isLastLevel) {
            const handleClick = () => {

                setPopupItem(accordionItem);
                setPopupOpen(true);
            };

            return (
                <div key={accordionItem.orderDepartment} style={{marginBottom: 5}}>
                    <Button
                        onClick={handleClick}
                        startIcon={<AiOutlineFile/>}
                        style={{
                            color: '#3872F2',
                            fontFamily: "'FiraGO-SemiBold'",
                            textTransform: 'none',
                            marginTop: 20
                        }}
                    >
                        {accordionItem.title}
                    </Button>
                </div>
            );
        }

        return (
            <Accordion
                image={accordionItem.icon || ''}
                key={accordionItem.id}
                title={accordionItem.title}
                accordionOrder={accordionItem.id}
                isLogin={accordionItem.id === 40}
            >
                {accordionItem.childrenPermitTypes.map(renderAccordion)}
            </Accordion>
        );
    };

    return (
        <div>
            {isLoading ? <div><ServicesLoader/></div> :
                <div className="accordion-grid">
                    {accordionData.map(renderAccordion)}
                </div>
            }

            <EntitySelectorDialog
                open={popupOpen}
                onClose={() => {
                    setPopupOpen(false);
                    setSelectedEntities({entity: null, explanationEntity: null});
                }}
                onSelect={(type, step) => {
                    if (!hasSecondStep) {
                        setSelectedEntities({entity: type, explanationEntity: null});
                        setPopupOpen(false);
                        navigate(`/dashboard/newcase?id=${popupItem.id}&parentId=${popupItem.permitTypeId || ''}&entity=${type}`);
                    } else if (step === 1) {
                        setSelectedEntities(prev => ({...prev, entity: type}));
                    } else {
                        setSelectedEntities(prev => {
                            const updated = {...prev, explanationEntity: type};
                            setPopupOpen(false);
                            navigate(`/dashboard/newcase?id=${popupItem.id}&parentId=${popupItem.permitTypeId || ''}&entity=${updated.entity}&explanationEntity=${updated.explanationEntity}`);
                            return updated;
                        });
                    }
                }}

                hasSecondStep={hasSecondStep}
            />


        </div>
    );
}

export default Services;
